/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

export default {
    title: 'VulcanoSmart Portal',
    company: 'ADV Project S.r.l.',
    urlWebApi: 'https://service.vulcanosmart.advproject.it'
    // urlWebApi: 'http://localhost:888'
    // urlWebApi: 'http://service.test.vulcanosmart.advproject.it' //
};
